export default __webpack_public_path__ + "static/media/ΚΕΝ_ΗΛ.ffa824a9.png";